import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * Šířka okna, pod kterou se hlavní navigace nevejde na jeden řádek a přepne se do mobilního režimu
 * (tlačítko menu v záhlaví, seznam se rozbalí pod záhlavím).
 * Stejnou hranici má breakpoint `nav` v `@theme` v apps/reza-ais-fe/src/styles.css (utilita `max-nav:` u tlačítka
 * menu v components/header/header.component.html) – CSS ji z TS převzít neumí, při změně upravit obě místa.
 * Tailwind `max-nav:` znamená `width < 77.5rem` (1240 px), tedy totéž co `max-width: 1239px` u menubaru.
 * Při písmu 16 px má menu 1120 px a do jednoho řádku se vejde od šířky okna 1221–1230 px (měřeno 22. 10. 2026).
 */
export const MOBILE_NAV_BREAKPOINT = '1239px';

/** Propojení tlačítka menu v záhlaví s hlavní navigací (navbar), které jsou samostatné komponenty. */
@Injectable({ providedIn: 'root' })
export class MobileNavService {
  /** Kliknutí na tlačítko menu v záhlaví; navbar podle něj rozbalí / sbalí mobilní seznam navigace. */
  readonly toggle$ = new Subject<MouseEvent>();
}
